(ns rlws.iot-cloud.frontend.site
  "Plain IDs are a reference to the unique part of a URI key from site as a user
  would expect to be shown or manipulate themselves, we exchange plain to site
  and site to plain IDs throughout the application where required."
  (:require [clojure.string :as str]
            [rlws.iot-cloud.frontend.config :as config]
            [rlws.iot-cloud.frontend.ajax :as ajax]))

(def -resource-paths
  {:assets (str config/api-path "/assets/")
   :alerts (str config/api-path "/alerts/")
   :customers (str config/api-path "/customers/")
   :sites (str config/api-path "/sites/")
   :iqubes (str config/api-path "/iqubes/")
   :scales (str config/api-path "/scales/") 
   :dealerships (str config/api-path "/orgs/")
   :documents (str config/api-path "/documents/")
   :images (str config/api-path "/images/")
   :service-notes (str config/api-path "/service-notes/")
   :users (str config/site-api-path "/users/")})

(defn resource-path
  ([type]
   (-resource-paths type))
  ([type id]
   (str (resource-path type) id)))

(defn to-plain-id
  "Get a plain id from a site uri"
  [{crux-id :crux.db/id id :id :as s}]
  (try
    (last (str/split (.-pathname (js/URL. (or crux-id id s ""))) #"/"))
    (catch :default e
      (or id s))))

(defn to-site-uri
  "Produce a uri from a plain id and a type"
  [type id]
  (assert (keyword? type) "Type must be a keyword")
  (str config/site-api-origin (resource-path type id)))

(defn walk-plain-ids
  "Removes namespacing and underscoring from crux results, coercing uris to their
  plain representations in the id position"
  [m]
  (clojure.walk/postwalk
   (fn [x]
     (cond
       (map-entry? x)
       [(-> (key x)
            name
            (str/replace-first #"^_" "")
            keyword)

        (if (= :crux.db/id (key x))
          (to-plain-id (val x))
          (val x))]

       :else x))
   m))

;; Site API

(defn add-image
  [image-id for-id image-data]
  (ajax/put-request
   (str config/site-api-origin (resource-path :images image-id))
   {:data image-data
    :for for-id
    :type "Image"}
   [:rlws.iot-cloud.frontend.events/log-message "Added image"]
   [:rlws.iot-cloud.frontend.events/log-message "Failed to add image"]))

(defn get-images-for
  [type id on-success]
  (ajax/get-request
   (str config/site-api-origin (resource-path :images))
   on-success
   [:rlws.iot-cloud.frontend.events/log-message]
   {:for (to-site-uri type id)}))

(defn put-asset
  [asset-data on-success on-failure]
  (let [asset-id (:gateway asset-data)
         {:keys [components add-image-events]}
         (reduce
          (fn [reduction component]
            (if-let [{:keys [:crux.db/id data]} (:image component)]
              (let [image-id (or (to-plain-id id) (random-uuid))
                    new-component (assoc component :image (to-site-uri :images image-id))
                    add-image-event [:rlws.iot-cloud.frontend.events/add-image
                                     image-id
                                     (to-site-uri :assets asset-id)
                                     data]]
                (-> reduction
                    (update :components conj new-component)
                    (update :add-image-events conj add-image-event)))
              (update reduction :components conj component)))
          {:components []
           :add-image-events []}
          (:components asset-data))]
     (merge (ajax/put-request
             (str config/site-api-origin (resource-path :assets (:gateway asset-data)))
             (assoc asset-data :components components)
             on-success
             on-failure)
            {:fx [[:dispatch-n add-image-events]]})))
